import { useCurrentUser } from '@economic/react-app';
import { useEffect } from 'react';

declare global {
    interface Window {
        Txt: any;
    }
}

const buildUnlessProfile = profile => {
    const excludedKeys = ['unlessId', 'profileId', 'emailAddress'];
    const nonTextKeys = {
        agreementSignupDate: 'date',
        demoDateEnd: 'date',
        glnActivated: 'date',
        superUser: 'bool',
        trialSignupDate: 'date',
        userDeregDate: 'date',
        userSignupDate: 'date',
    };

    return Object.keys(profile)
        .filter(k => !excludedKeys.includes(k))
        .map(k => {
            const type = nonTextKeys?.[k] ?? 'text';
            return { key: k, value: `${profile[k]}`, type, custom: true };
        });
};

export const useUnless = () => {
    const user = useCurrentUser();
    const { unlessProfile } = user.extra;

    useEffect(() => {
        if (!unlessProfile?.unlessId) {
            return;
        }

        const txtLoaded = () => {
            if (window.Txt) {
                const unlessData = buildUnlessProfile(unlessProfile);
                window.Txt.identify(unlessProfile?.emailAddress, unlessData, unlessProfile?.profileId);
            }
        };

        document.addEventListener('txt-loaded', txtLoaded);

        const script = document.createElement('script');
        script.setAttribute('data-unless', '1.2');
        script.setAttribute('data-installer', 'snippet');
        script.innerText = `!function(o,p,t,i,m,a,l){function s(e){o.documentElement.style.opacity=e}function d(e){i.parentNode.insertBefore(e,i)}s((window.TxtOptions||{}).asyncMode?"":0),setTimeout(function(){s("")},3e3),i=(o.head||o.documentElement).firstChild,l="https://"+t+".unless.com/js/v5/latest/txt.min.js?id="+t+"&domain="+window.location.hostname,(m=o.createElement("link")).href=l,m.rel="preconnect preload",m.as=p,d(m),(a=o.createElement(p)).src=l,d(a),a.onerror=function(){s("")}}(document,"script","${unlessProfile?.unlessId}");`;
        document.head.appendChild(script);

        return () => document.removeEventListener('txt-loaded', txtLoaded);
    }, []);
};
